import { Avatar as AvatarPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { initials } from '../../lib/format.js';

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Decorative when the name is shown next to it (default true). */
  decorative?: boolean;
}

const SIZES = { sm: 'size-7 text-meta', md: 'size-9 text-meta', lg: 'size-11 text-body' } as const;

export const Avatar = React.forwardRef<HTMLSpanElement, AvatarProps>(function Avatar({ name, src, size = 'md', className, decorative = true }, ref) {
  return (
    <AvatarPrimitive.Root
      ref={ref}
      aria-hidden={decorative || undefined}
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-pill bg-accent-selected font-semibold text-accent-on-selected',
        SIZES[size],
        className,
      )}
    >
      {src ? <AvatarPrimitive.Image src={src} alt={decorative ? '' : name} className="size-full object-cover" /> : null}
      <AvatarPrimitive.Fallback aria-label={decorative ? undefined : name} delayMs={src ? 300 : 0}>
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
});
